import { useQuery } from "@tanstack/react-query";
import SubLabel from "components/Atoms/Sublabel";
import { GooglePlaceInput } from "components/ValidatedFields/GooglePlaceInput";
import React from "react";
import { Loader } from "semantic-ui-react";
import Removable, { RemovableLabel, type RemovableProps } from "./Removable";

const RemovableTrainStation = (props: RemovableProps<server.dto.TrainStation>) => {
  const [selectedPlace, setSelectedPlace] = React.useState<server.dto.GooglePlaceAutocomplete>(null);

  const trainQuery = useQuery({
    queryKey: ["trainstation", selectedPlace?.placeId],
    queryFn: async () => window.Api.Trains.GetTrainStation(selectedPlace.placeId).then(r => r.data),
    enabled: selectedPlace != null,
    onSuccess: res => {
      props.onChange(res);
      setSelectedPlace(null);
    }
  });

  const isTrainQueryLoading = trainQuery.isLoading && selectedPlace != null;

  return <Removable<server.dto.TrainStation>
    renderRemovableLabel={RemovableTrainStationLabel}
    {...props}
  >
    {isTrainQueryLoading
      ? <Loader active inline size="small" />
      : <GooglePlaceInput
        onPlaceSelected={v => setSelectedPlace({
          placeId: v.id,
          mainText: v.name,
          secondaryText: v.address
        })}
        hasError={props.error}
        types={["transit_station"]}
      />}
  </Removable>;
};

const RemovableTrainStationLabel = (props: RemovableProps<server.dto.TrainStation>) => {
  return <RemovableLabel {...props}>
    <div>
      {props.value.name}
      <SubLabel small>
        {props.value.address.formatted.join(", ")}
      </SubLabel>
    </div>
  </RemovableLabel>;
};

export default RemovableTrainStation;